export class WebApiCalls {
    _BASE_URL = process.env.REACT_APP_BASE_URL;
    //Login EndPoint
    _LOGIN_USER = '/user/login';
    //Forget Password
    _FORGET_PASSWORD = '/user/forgetPassword';
    // OTP Verification
    _VERIFY_OTP = '/user/verifyOtp';

    // Resend OTP
    _RESEND_OTP = '/user/resendOtp';

    //Update Pass
    _UPDATE_PASS = '/user/update-password';

    //Update Profile
    _UPDATE_PROFILE = '/user/update-profile';

    // Get User Setting
    _USER_SETTINGS = '/user/settings';

    //common settings
    _COMMON_DASHBOARD = '/common/dashboard';
    _ALL_COMMUTERS = '/commuter';
    _COMMUTER_DASHBOARD = '/commuter/dashboard';

    _GET_ALL_COMMUTERS = '/commuter/all/commuters';
    _UDPATED_SINGLE_COMMUTER = '/commuter/update';
    _UPDATE_BULK_COMMUTER = '/commuter/update-many';
    _DELETE_BULK_COMMUTER = '/commuter/delete-many';
    _GET_COMMUTER_LOCATIONS = '/location/getLocations';
    _SAVE_COMMUTER_LOCATION = '/location/:id/add';
    _DELETE_COMMUTER_LOCATION = '/location/delete';
    _UPDATE_COMMUTER_PROFILE = '/commuter/update-profile';
    _DELETE_COMMUTER = '/commuter/delete';
    _SET_DEFAULT_LOCATION = '/location/set-default-location';

    //Agency constants
    _ALL_AGENCIES = '/transit-agency/getAll';
    //Add Agency
    _ADD_AGENCY = '/user/register';

    //Agency Rewards

    //Update Agency

    // Reward Point Settings
    _REWARD_SETTINGS = '/reward/setting';
    _PAYMENT_SETTINGS = '/payment/create-stripe-agency-account';
    _CREATE_PAYMENT = '/payment/create-payment';
    _CREATE_PAYMENT_INTENT = '/payment/create-payment-intent';
    //Get Single Agency
    _GET_SINGLE_AGENCY = '/transit-agency/get';
    //UPDATE Single agency
    _UPDATE_AGENCY = '/transit-agency/update';
    // Update Bulk agencies
    _UPDATE_BULK_AGENCIES = '/transit-agency/update-many';
    //Delete Agency
    _DELETE_AGENCY = '/transit-agency/delete';
    // Delete Bulk
    _DELETE_BULK_AGENCIES = '/transit-agency/delete-many';

    //Get all stations
    _ALL_STATIONS = '/station/getAll';

    //Get all stations for an agency
    _GET_STATIONS_BY_AGENCY = '/station/stations-by-agency/:id';

    // Get next stations by selected trip and start station
    _GET_NEXT_STATIONS_BY_AGENCY = '/station/next-stations/:id';

    // Create A station against single Route
    _ADD_STATION = '/station/create';
    // get A station detials
    _STATION_DETAILS = '/station/get';
    // Update station detials
    _STATION_UPDATE = '/station/update';
    // Update station detials
    _STATION_DELETE = '/station/delete';
    _STATION_BULK_DELETE = '/station/delete-many';

    //Get All Routes
    _GET_ALL_ROUTES = '/route/getAll';

    //Add Route
    _ADD_ROUTE = '/route/create';

    //Get Single Route
    _GET_SINGLE_ROUTE = '/route/get';
    _GET_SINGLE_ROUTE_TRIPS = '/route/get-trips';
    _GET_ASSOCIATED_ROUTES = '/route/get-associated-routes';
    _GET_ROUTES_BY_AGENCY = '/route/by-agency';
    // Update route
    _UPDATE_ROUTE = '/route/update';
    // Update Bulk Routes
    _UPDATE_BULK_ROUTE = '/route/update-many';
    //Delete Route
    _DELETE_ROUTE = '/route/delete';
    // Delete Bulk
    _DELETE_BULK_ROUTE = '/route/delete-many';

    //Get All Rewards
    _GET_ALL_REWARDS = '/reward';
    //Get  Rewards details
    _GET_REWARDS_details = '/reward/detials';
    //Delete Reward
    _DELETE_REWARD = '/reward/delete';
    // Update Bulk Vendors
    _UPDATE_BULK_REWARDS = '/reward/update-many';
    // Delete Bulk Vendors
    _DELETE_BULK_REWARDS = '/reward/delete-many';
    //Update Reward
    _UPDATE_REWARD = '/reward/update';
    //create Reward
    _CREATE_REWARD = '/reward/';

    // Redeem rewards list
    _ALL_REDEEM_REWARDS = '/reward/redeem-rewards';
    //_DELETE_REDEEM_POINTS
    _DELETE_REDEEM_REWARD = 'reward/redeem/delete';
    // get single record
    _GET_SINGLE_VENDOR = '/vendor/get';

    // create new vendor
    _CREATE_VENDOR = '/user/register';
    // All Vendors
    _ALL_VENDORS = '/vendor/getAll';

    //Delete Vendor
    _UPDATE_VENDOR = '/vendor/update';
    // Update Bulk Vendors
    _UPDATE_BULK_VENDORS = '/vendor/update-many';
    // Delete Bulk Vendors
    _DELETE_BULK_VENDORS = '/vendor/delete-many';

    //Delete Vendor
    _DELETE_VENDOR = '/vendor/delete';

    // Awarded Points
    _ALL_AWARDED_POINTS = '/trip/awarded-points';

    //Single Awarded Points

    //Awarded Points
    _DELETE_AWARDED_POINTS = '/trip/awarded-points/delete';
    //Bulk Delete Awarded Points
    _DELETE_BULK_AWARDED_POINTS = '/trip/delete-many';

    // trips
    _GET_ALL_TRIPS = '/trip';
    _GET_STRIPE_AGENCY_ACCOUNT = '/payment/get-stripe-agency-account';
    _DELETE_STRIPE_AGENCY_ACCOUNT = '/payment/delete-stripe-agency-account';
    _DELETE_TRIP = '/trip/delete';
    _DELETE_BOOKING = '/bookings/delete';
    _DELETE_BULK_TRIPS = '/trip/delete-many';
    _DELETE_BULK_BOOKINGS = '/bookings/delete-many';
    _TRIP_DETAILS = '/trip/get';
    _BOOKING_DETAILS = '/bookings/get';
    _FUNDTRANSFER = '/payment/transfer-funds';
    _TRIP_ALL_DATA = '/trip/get-trips-all';
    _TRIP_ALL_BOOKING_DATA = '/bookings/get-booking-trips-all';
    _TRIP_ALL_BOOKING_DATA_AGENCY = '/bookings/get-booking-trips-all-agency';
    _BOOKINGS_CONFIG = '/user/bookings-config';
    // Image upload
    _IMAGE_UPLOAD = '/common/upload';
    _GOOGLE_LOGIN = '/oauth/google/login';
    _USER_NOTIFICATIONS = '/user-notifications/get-notifications';
    _UPDATE_USER_NOTIFICATIONS = '/user-notifications/update-notifications';

    // demographics
    _SAVE_DEMOGRAPHICS = '/demographics/save';
    _GET_ALL_DEMOGRAPHIC_REWARDS = '/demographics/rewards';
    _UPDATE_DEMOGRAPHIC_REWARD = '/demographics/reward/update';

    // Offers
    _CREATE_OFFER = '/offer/create';
    _LIST_OFFERS = '/offer/list';
    _UPDATE_OFFER = '/offer/update';
    _DELETE_OFFER = '/offer/delete';

    // Offer Menu Items
    _CREATE_MENU_ITEM = '/offer/menu-item/create';
    _LIST_MENU_ITEMS = '/offer/menu-item/list';
    _GET_MENU_ITEM = '/offer/menu-item';
    _UPDATE_MENU_ITEM = '/offer/menu-item/update';
    _UPDATE_BULK_MENU_ITEMS = '/offer/menu-item/update-many';
    _DELETE_MENU_ITEM = '/offer/menu-item/delete';
    _DELETE_BULK_MENU_ITEMS = '/offer/menu-item/delete-bulk';

    // Branches
    _CREATE_BRANCH = '/branch/create';
    _LIST_BRANCHES = '/branch/list';
    _UPDATE_BRANCH = '/branch/update';
    _DELETE_BRANCH = '/branch/delete';

    // Redemption
    _REDEMPTION_ANALYTICS = '/redemption/analytics';
    _REDEMPTION_HISTORY = '/redemption/history/getAll';
    _GET_COMMUTER_REDEMPTION_HISTORY = '/redemption/commuter';
    _DELETE_REDEMPTION_HISTORY = '/redemption/delete';
    _DELETE_BULK_REDEMPTION_HISTORY = '/redemption/delete-bulk';
    _REDEEM_REWARD = '/redemption/vendor-redeem';

    // Conversion Tiers
    _GET_CONVERSION_TIERS = '/conversion-tiers';

    // Agency analytics
    _AGENCY_ANALYTICS = '/analytics/agency-dashboard';

    sendRequest = async (url, req) => {
        try {
            let response = await fetch(url, req);
            let responseJson = await response.json();

            if (responseJson?.code === 401) {
                window.localStorage.removeItem('user');
                window.location.href = window.location.origin;
                return;
            }

            return responseJson;
        } catch (error) {
            let err = [];
            err.error = error;
            err.no_result = true;
            return err;
        }
    };

    getLoggedIn = (obj) => {
        let url = `${this._BASE_URL}${this._LOGIN_USER}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    getGoogleLoggedIn = (obj) => {
        let url = `${this._BASE_URL}${this._GOOGLE_LOGIN}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    forgetPassword = (obj) => {
        let url = `${this._BASE_URL}${this._FORGET_PASSWORD}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    //get associated routes
    getAssociatedRoutes = (token, data) => {
        const { type } = data;
        const entityId = type === 'agency' ? data.agency_id : data.vendor_id;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let url = `${this._BASE_URL}${this._GET_ASSOCIATED_ROUTES}?entityId=${entityId}&type=${type}`;
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getRoutesByAgency = (token, agencyId, agencyType, page = 1, limit = 20) => {
        let url = `${this._BASE_URL}${this._GET_ROUTES_BY_AGENCY}?agencyId=${agencyId}&agencyType=${agencyType}&page=${page}&limit=${limit}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getRouteTrips = (token, routeId, search, pageNo = 1, pageSize = 10) => {
        let url = `${this._BASE_URL}${this._GET_SINGLE_ROUTE_TRIPS}/${routeId}?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    //Resend otp
    resendOtp = (obj) => {
        let url = `${this._BASE_URL}${this._RESEND_OTP}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    userOtpVerification = (obj) => {
        let url = `${this._BASE_URL}${this._VERIFY_OTP}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    //Resend OTP here

    //Update Pass here
    updatePassword = (token, obj) => {
        let url = `${this._BASE_URL}${this._UPDATE_PASS}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('x-access-token', token);
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    getUserSettings = (token) => {
        let url = `${this._BASE_URL}${this._USER_SETTINGS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    udpateSettings = (token, obj) => {
        let url = `${this._BASE_URL}${this._UPDATE_PROFILE}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('x-access-token', token);
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    udpateCommuterSettings = (token, obj) => {
        let url = `${this._BASE_URL}${this._UPDATE_COMMUTER_PROFILE}`;
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('x-access-token', token);
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    getCommonSettings = (token) => {
        let url = `${this._BASE_URL}${this._COMMON_DASHBOARD}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    //JSON.parse(authToken), pageSize, pageNo, _status, _search
    getPaginatedCommuters = (token, pageSize = 10, pageNo = 1, _status, _search, _region = '', _city = '') => {
        let url = `${this._BASE_URL}${this._ALL_COMMUTERS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        if (_region) {
            url = `${url}&_region=${_region}`;
        }
        if (_city) {
            url = `${url}&_city=${_city}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    //get all commuters for csv
    getAllCommuters = (token) => {
        let url = `${this._BASE_URL}${this._GET_ALL_COMMUTERS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getCommuterDasboardData = (token, userId, startDate, endDate) => {
        let url = `${this._BASE_URL}${this._COMMUTER_DASHBOARD}/${userId}?dateFrom=${startDate}&dateTo=${endDate}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getSingleCommuter = (token, id) => {
        let url = `${this._BASE_URL}${this._ALL_COMMUTERS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateCommuter = (token, obj, id) => {
        let url = `${this._BASE_URL}${this._UDPATED_SINGLE_COMMUTER}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    deleteCommuter = (token, id) => {
        let url = `${this._BASE_URL}${this._ALL_COMMUTERS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    // get commuter locations
    getCommuterLocations = (token) => {
        let url = `${this._BASE_URL}${this._GET_COMMUTER_LOCATIONS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // save commuter locations
    saveCommuterLocation = (token, id, obj) => {
        let url = `${this._BASE_URL}${this._SAVE_COMMUTER_LOCATION.replace(':id', id)}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    // delete commuter location
    deleteLocation = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_COMMUTER_LOCATION}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({ location: id })
        };
        return this.sendRequest(url, request);
    };

    // set commuter default location
    setDefaultLocation = (token, id) => {
        let url = `${this._BASE_URL}${this._SET_DEFAULT_LOCATION}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({ locationId: id })
        };
        return this.sendRequest(url, request);
    };

    // bulkk

    updateBulkCommuter = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._UPDATE_BULK_COMMUTER}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While updatig bulk agencies', error);
        }
    };

    deleteBulkCommuter = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_COMMUTER}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk commuters', error);
        }
    };

    // get all angencies
    getAllAgencies = (token, pageSize = 10, pageNo = 0, _transitType = '', _status, _search) => {
        let url = `${this._BASE_URL}${this._ALL_AGENCIES}?pageSize=${pageSize}&pageNo=${pageNo}`;
        // let url = `${this._BASE_URL}${this._GET_ALL_ROUTES}?pageSize=${pageSize}&pageNo=${pageNo}`;

        if (_transitType) {
            url = `${url}&_transitType=${_transitType}`;
        }
        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getSingleAgency = (token, id) => {
        let url = `${this._BASE_URL}${this._GET_SINGLE_AGENCY}/${id}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateAgency = (token, obj, id) => {
        let url = `${this._BASE_URL}${this._UPDATE_AGENCY}/${id}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    addNewAgency = (token, obj) => {
        let url = `${this._BASE_URL}${this._ADD_AGENCY}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    updateBulkAgencies = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._UPDATE_BULK_AGENCIES}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While updatig bulk agencies', error);
        }
    };

    deleteBulkAgencies = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_AGENCIES}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk routes', error);
        }
    };

    deleteAgency = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_AGENCY}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getAllRoutes = (token, agency_id = '', _transitType = '', pageSize, pageNo, _status, _search) => {
        let url = `${this._BASE_URL}${this._GET_ALL_ROUTES}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (agency_id) {
            url = `${url}&transit_agency=${agency_id}`;
        }
        if (_transitType) {
            url = `${url}&_transitType=${_transitType}`;
        }
        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getAllBookingRoutes = (token, pageSize, pageNo, _search, startDate, endDate, transitFilter) => {
        let url = `${this._BASE_URL}${this._TRIP_ALL_BOOKING_DATA}?pageSize=${pageSize}&pageNo=${pageNo}&startDate=${startDate}&endDate=${endDate}`;

        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        if (transitFilter) {
            url = `${url}&_transitFilter=${transitFilter}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getAllBookingAgencyRoutes = (token, pageSize, pageNo, _search, startDate, endDate, transitFilter) => {
        let url = `${this._BASE_URL}${this._TRIP_ALL_BOOKING_DATA_AGENCY}?pageSize=${pageSize}&pageNo=${pageNo}&startDate=${startDate}&endDate=${endDate}`;

        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        if (transitFilter) {
            url = `${url}&_transitFilter=${transitFilter}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    addRoute = (token, obj) => {
        let url = `${this._BASE_URL}${this._ADD_ROUTE}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    getSingleRoute = (token, id, station) => {
        let url = `${this._BASE_URL}${this._GET_SINGLE_ROUTE}/${id}?station=${station}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateBulkRoute = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._UPDATE_BULK_ROUTE}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While updatig bulk routes', error);
        }
    };

    deleteBulkRoute = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_ROUTE}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk routes', error);
        }
    };

    updateRoute = (token, obj, id) => {
        let url = `${this._BASE_URL}${this._UPDATE_ROUTE}/${id}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    deleteRoute = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_ROUTE}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    //Reward APIs
    getAllRewards = (token, pageSize = 10, pageNo = 0, _status = '', _search = '', agencyId = '', vendorId = '', noLimit = false) => {
        let url = `${this._BASE_URL}${this._GET_ALL_REWARDS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (agencyId) {
            url = `${url}&transitAgencyId=${agencyId}`;
        }
        if (vendorId) {
            url = `${url}&vendorId=${vendorId}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (noLimit) {
            url = `${url}&noLimit=${noLimit}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    //Reward API detials
    getRewardsDetials = (token, id) => {
        let url = `${this._BASE_URL}${this._GET_REWARDS_details}/${id}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // Rewards bulk
    updateBulkRewards = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._UPDATE_BULK_REWARDS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While updatig bulk Rewards', error);
        }
    };

    deleteBulkRewards = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_REWARDS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk Rewards', error);
        }
    };
    updateReward = (token, obj, id) => {
        let url = `${this._BASE_URL}${this._UPDATE_REWARD}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'PUT',
            body: JSON.stringify(obj),
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    createReward = (token, obj) => {
        let url = `${this._BASE_URL}${this._CREATE_REWARD}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    deleteReward = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_REWARD}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'PUT',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // VENDORS
    getAllVendors = (token, pageSize, pageNo, _status, _search) => {
        let url = `${this._BASE_URL}${this._ALL_VENDORS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getSingleVendor = (token, id) => {
        let url = `${this._BASE_URL}${this._GET_SINGLE_VENDOR}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    createVendor = (token, obj) => {
        let url = `${this._BASE_URL}${this._CREATE_VENDOR}`;
        const myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        const request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    updateVendor = (token, obj, id) => {
        let url = `${this._BASE_URL}${this._UPDATE_VENDOR}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    deleteVendor = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_VENDOR}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateBulkVendors = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._UPDATE_BULK_VENDORS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While updatig bulk routes', error);
        }
    };

    deleteBulkVendors = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_VENDORS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk Vendors', error);
        }
    };

    getAllBranches = async (token, pageSize = 10, pageNo = 0, status, search) => {
        const url = `${this._BASE_URL}${this._LIST_BRANCHES}?pageSize=${pageSize}&pageNo=${pageNo}&_status=${status}&_search=${search}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    deleteBranch = async (token, branchId) => {
        const url = `${this._BASE_URL}${this._DELETE_BRANCH}/${branchId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateBranch = async (token, branchId, body) => {
        const url = `${this._BASE_URL}${this._UPDATE_BRANCH}/${branchId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };

    createBranch = (token, branchData) => {
        let url = `${this._BASE_URL}${this._CREATE_BRANCH}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(branchData)
        };
        return this.sendRequest(url, request);
    };

    getAllOffers = async (token, branchId = '', pageSize = 10, pageNo = 1, status, search) => {
        const url = `${this._BASE_URL}${this._LIST_OFFERS}?branchId=${branchId}&pageSize=${pageSize}&pageNo=${pageNo}&_status=${status}&_search=${search}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    deleteOffer = async (token, offerId) => {
        const url = `${this._BASE_URL}${this._DELETE_OFFER}/${offerId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    createOffer = (token, offerData) => {
        let url = `${this._BASE_URL}${this._CREATE_OFFER}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(offerData)
        };
        return this.sendRequest(url, request);
    };

    updateOffer = (token, offerId, offerData) => {
        let url = `${this._BASE_URL}${this._UPDATE_OFFER}/${offerId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(offerData)
        };
        return this.sendRequest(url, request);
    };

    // Fetch Offer Details
    getOfferDetails = (token, offerId) => {
        let url = `${this._BASE_URL}${this._LIST_OFFERS}/${offerId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // Fetch Branch Details
    getBranchDetails = (token, branchId) => {
        let url = `${this._BASE_URL}${this._LIST_BRANCHES}/${branchId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // Awarded Points
    getAllAwardsPoints = (token, pageSize, pageNo, _search) => {
        let url = `${this._BASE_URL}${this._ALL_AWARDED_POINTS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    deleteBulkAwardedPoints = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_AWARDED_POINTS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk Vendors', error);
        }
    };
    //awarded-points/delete/:id
    deleteAwardedPoints = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_AWARDED_POINTS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    // Redeem Rewards points
    getAllRedeemPoints = (token, pageSize, pageNo, _search) => {
        let url = `${this._BASE_URL}${this._ALL_REDEEM_REWARDS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    //delete redeem rewards
    deleteRedeemRewards = (token, body) => {
        let url = `${this._BASE_URL}${this._DELETE_REDEEM_REWARD}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };

    // Get Rewards Setting
    getRewardSettings = (token) => {
        let url = `${this._BASE_URL}${this._REWARD_SETTINGS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    stripeConnectAccount = (token, body) => {
        let url = `${this._BASE_URL}${this._PAYMENT_SETTINGS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };
    createPayment = (token, body) => {
        let url = `${this._BASE_URL}${this._CREATE_PAYMENT}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };
    createPaymentIntent = (token, body) => {
        let url = `${this._BASE_URL}${this._CREATE_PAYMENT_INTENT}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };
    // Get Rewards Setting
    getAllTripsPdf = (token, routeId, favourite) => {
        let url = `${this._BASE_URL}${this._TRIP_ALL_DATA}?routeId=${routeId}&isFavourite=${favourite}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    // Rewards Setting
    updateRewardSettings = (token, obj) => {
        let url = `${this._BASE_URL}${this._REWARD_SETTINGS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    // Stations against single Route
    getAllStations = (token, pageSize, pageNo, _status, _search, route, agency) => {
        let url = `${this._BASE_URL}${this._ALL_STATIONS}?pageSize=${pageSize}&pageNo=${pageNo}&route=${route || ''}`;

        if (_status) {
            url = `${url}&_status=${_status}`;
        }
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        if (agency) {
            url = `${url}&agency_ids=${agency}`;
        }

        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // Stations against single Route
    getStationsByAgency = (token, id) => {
        let url = `${this._BASE_URL}${this._GET_STATIONS_BY_AGENCY.replace(':id', id)}`;

        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');

        let request = {
            method: 'GET',
            headers: myHeaders
        };

        return this.sendRequest(url, request);
    };

    // Next stations by selected trip and start station
    getNextStationsByTransitAgency = (token, id, stationId) => {
        let url = `${this._BASE_URL}${this._GET_NEXT_STATIONS_BY_AGENCY.replace(':id', id)}?stationId=${stationId}`;

        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');

        let request = {
            method: 'GET',
            headers: myHeaders
        };

        return this.sendRequest(url, request);
    };

    //Adding station against single route
    addStation = (token, obj) => {
        let url = `${this._BASE_URL}${this._ADD_STATION}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    stationDetials = (token, id) => {
        let url = `${this._BASE_URL}${this._STATION_DETAILS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    getStripeAccount = (token) => {
        let url = `${this._BASE_URL}${this._GET_STRIPE_AGENCY_ACCOUNT}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    deleteStripeAccount = (token) => {
        let url = `${this._BASE_URL}${this._DELETE_STRIPE_AGENCY_ACCOUNT}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'delete',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    stationUpdate = (token, id, obj) => {
        let url = `${this._BASE_URL}${this._STATION_UPDATE}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    stationDelete = (token, id) => {
        let url = `${this._BASE_URL}${this._STATION_DELETE}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    stationBulkDelete = (token, body) => {
        let url = `${this._BASE_URL}${this._STATION_BULK_DELETE}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };
    // get all Trips
    getAllTrips = (token, pageSize = 10, pageNo = 0, _search, startDate = '', endDate = '') => {
        let url = `${this._BASE_URL}${this._GET_ALL_TRIPS}?pageSize=${pageSize}&pageNo=${pageNo}&startDate=${startDate}&endDate=${endDate}`;
        // let url = `${this._BASE_URL}${this._GET_ALL_ROUTES}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (_search) {
            url = `${url}&_search=${_search}`;
        }
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    tripDelete = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_TRIP}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    bookingDelete = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_BOOKING}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    deleteBulkTrips = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_TRIPS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk Trips', error);
        }
    };
    deleteBulkBookings = (token, body) => {
        try {
            let url = `${this._BASE_URL}${this._DELETE_BULK_BOOKINGS}`;
            let myHeaders = new Headers();
            myHeaders.append('x-access-token', token);
            myHeaders.append('Content-Type', 'application/json');
            const request = {
                method: 'PUT',
                headers: myHeaders,
                body: JSON.stringify(body)
            };
            return this.sendRequest(url, request);
        } catch (error) {
            console.log('ERROR While delete bulk Trips', error);
        }
    };
    tripDetials = (token, id) => {
        let url = `${this._BASE_URL}${this._TRIP_DETAILS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    bookingDetials = (token, id) => {
        let url = `${this._BASE_URL}${this._BOOKING_DETAILS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    userNotifications = (token, id) => {
        let url = `${this._BASE_URL}${this._USER_NOTIFICATIONS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    updateNotifications = (token, id, obj) => {
        let url = `${this._BASE_URL}${this._UPDATE_USER_NOTIFICATIONS}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };
    refundTransfer = (token) => {
        let url = `${this._BASE_URL}${this._FUNDTRANSFER}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };
    updateUserBookingConfig = (token, obj) => {
        let url = `${this._BASE_URL}${this._BOOKINGS_CONFIG}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');

        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(obj)
        };
        return this.sendRequest(url, request);
    };

    //Upload any image
    uploadImages = (token, obj) => {
        let url = `${this._BASE_URL}${this._IMAGE_UPLOAD}`;
        let header = new Headers();
        header.append('x-access-token', token);
        let request = {
            method: 'POST',
            headers: header,
            body: obj
        };
        return this.sendRequest(url, request);
    };
    // save _SAVE_DEMOGRAPHICS
    saveDemographics = (token, body) => {
        let url = `${this._BASE_URL}${this._SAVE_DEMOGRAPHICS}`;
        let header = new Headers();
        header.append('x-access-token', token);
        let request = {
            method: 'POST',
            headers: header,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };

    // get _GET_DEMOGRAPHICS
    getDemographics = (token) => {
        let url = `${this._BASE_URL}${this._GET_ALL_DEMOGRAPHIC_REWARDS}`;
        let header = new Headers();
        header.append('x-access-token', token);
        let request = {
            method: 'GET',
            headers: header
        };
        return this.sendRequest(url, request);
    };
    // update demographic reward, _UPDATE_DEMOGRAPHIC_REWARD
    updateDemographicReward = (token, body, id) => {
        let url = `${this._BASE_URL}${this._UPDATE_DEMOGRAPHIC_REWARD}/${id}`;
        let header = new Headers();
        header.append('x-access-token', token);
        let request = {
            method: 'PUT',
            headers: header,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };

    async getConversionTiers(token) {
        return this.apiCall(this._GET_CONVERSION_TIERS, 'GET', null, token);
    }

    getRedemptionHistory = async (token, pageSize, pageNo, search, vendorId, startDate, endDate, commuterId = '', branchId = '') => {
        const url = `${this._BASE_URL}${this._REDEMPTION_HISTORY}?vendorId=${vendorId}&pageSize=${pageSize}&pageNo=${pageNo}&search=${search || ''}&startDate=${
            startDate || ''
        }&endDate=${endDate || ''}&commuterId=${commuterId || ''}&branchId=${branchId || ''}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getCommuterRedemptionHistory = (token, commuterId, pageSize, pageNo, search = '', branchId = '') => {
        let url = `${this._BASE_URL}${this._GET_COMMUTER_REDEMPTION_HISTORY}/${commuterId}?pageSize=${pageSize}&pageNo=${pageNo}&search=${search || ''}&branchId=${
            branchId || ''
        }`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    deleteRedemptionHistory = async (token, payload) => {
        let url = `${this._BASE_URL}${this._DELETE_REDEMPTION_HISTORY}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders,
            body: JSON.stringify(payload)
        };
        return this.sendRequest(url, request);
    };

    deleteBulkRedemptionHistory = async (token, payload) => {
        let url = `${this._BASE_URL}${this._DELETE_BULK_REDEMPTION_HISTORY}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders,
            body: JSON.stringify(payload)
        };
        return this.sendRequest(url, request);
    };

    vendorRedeemRedemption = (token, payload) => {
        let url = `${this._BASE_URL}${this._REDEEM_REWARD}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(payload)
        };
        return this.sendRequest(url, request);
    };

    getVendorAnalytics = (token, vendorId, redemptionsRange = '7d', pointsRange = '7d') => {
        let url = `${this._BASE_URL}${this._REDEMPTION_ANALYTICS}?vendorId=${vendorId}&redemptionsRange=${redemptionsRange}&pointsRange=${pointsRange}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getAgencyDashboardKpis = (token, agencyId) => {
        let url = `${this._BASE_URL}${this._AGENCY_ANALYTICS}/${agencyId}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    // Menu Items CRUD
    createMenuItem = (token, data) => {
        let url = `${this._BASE_URL}${this._CREATE_MENU_ITEM}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(data)
        };
        return this.sendRequest(url, request);
    };

    getMenuItems = (token, pageSize = 10, pageNo = 1, search = '', status = 'active') => {
        let url = `${this._BASE_URL}${this._LIST_MENU_ITEMS}?pageSize=${pageSize}&pageNo=${pageNo}`;
        if (search) url += `&_search=${search}`;
        if (status) url += `&_status=${status}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    getMenuItem = (token, id) => {
        let url = `${this._BASE_URL}${this._GET_MENU_ITEM}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'GET',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateMenuItem = (token, id, data) => {
        let url = `${this._BASE_URL}${this._UPDATE_MENU_ITEM}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(data)
        };
        return this.sendRequest(url, request);
    };

    deleteMenuItem = (token, id) => {
        let url = `${this._BASE_URL}${this._DELETE_MENU_ITEM}/${id}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders
        };
        return this.sendRequest(url, request);
    };

    updateBulkMenuItems = (token, body) => {
        let url = `${this._BASE_URL}${this._UPDATE_BULK_MENU_ITEMS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };

    deleteBulkMenuItems = (token, body) => {
        let url = `${this._BASE_URL}${this._DELETE_BULK_MENU_ITEMS}`;
        let myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');
        let request = {
            method: 'DELETE',
            headers: myHeaders,
            body: JSON.stringify(body)
        };
        return this.sendRequest(url, request);
    };
}

const _BASE_URL = process.env.REACT_APP_BASE_URL;
const _IMAGE_UPLOAD = '/common/upload';

//Upload any image
export default function uploadImages(token, obj) {
    let url = `${_BASE_URL}${_IMAGE_UPLOAD}`;
    let header = new Headers();
    header.append('x-access-token', token);
    let request = {
        method: 'POST',
        headers: header,
        body: obj
    };
    return this.sendRequest(url, request);
}
